import React, {useContext} from 'react'
import {Button} from '@salesforce/design-system-react'

import {MessagesContext} from '../../context/messagesContext'

const CancelButton = () => {

  const {setPages} = useContext(MessagesContext)

  const goBack = () => {
    setPages(prevPages => [...prevPages].slice(0,prevPages.length - 1))
  }

  return (
    <Button label="Cancel" onClick={() => goBack()} />
  )
}

export default CancelButton
